import { useQuery } from "react-query";
import { getParentOfficeHierarchy } from "../../../../actions/OfficeHierarchy";

export const useParentHierarchyByCode = (code, isParent) => {
  return useQuery(
    ["GetParentOfficeHierarchyByCode", code],
    () => getParentOfficeHierarchy(code, isParent),
    {
      refetchOnWindowFocus: false,
      enabled: !!code,
    }
  );
};
